module.exports = __webpack_public_path__ + "static/media/galerija_2014 (23).081f92d7.jpg";